import React from "react";
import classnames from "classnames";

import styles from "./ModalWrapper.scss";

class ModalWrapper extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    const {
      children,
      Modal,
      modalProps,
      modalClick,
      inlineTrigger
    } = this.props;

    return (
      <div className={classnames({ [styles.inlineTrigger]: inlineTrigger })}>
        <div
          onClick={this.handleShow}
          className={classnames({ [styles.inlineTrigger]: inlineTrigger })}
        >
          {children}
        </div>

        {this.state.show && (
          <Modal
            show={this.state.show}
            onHide={this.handleClose}
            modalClick={modalClick}
            {...modalProps}
          />
        )}
      </div>
    );
  }
}

export default ModalWrapper;



// WEBPACK FOOTER //
// ./src/components/common/modalWrapper/ModalWrapper.js